import { ReactNode } from 'react'

import { Headline } from 'components'

import styles from './PageHeadline.module.scss'

interface PageHeadline {
  className?: string
  headline: ReactNode
  headlineClassName?: string
  suffix: string
}
const PageHeadline = ({ className, headline, headlineClassName, suffix }: PageHeadline) => (
  <div className={[styles.headlineContainer, className].join(' ')}>
    <Headline className={[styles.headline, headlineClassName].join(' ')}>{headline}</Headline>
    <div className={styles.suffix}>{suffix}</div>
  </div>
)

export default PageHeadline
